import { ofType } from 'redux-observable';
import { delay, mapTo } from 'rxjs/operators';
import { actionTypes } from '../reducers/System';


// 애픽's
const incrementAsync = (action$: any) => (
  action$.pipe(
    ofType(actionTypes.INCREMENTEN),
    delay(1000),
    mapTo({ type: actionTypes.DECREMENT }),
  )
);

export default incrementAsync;


// WEBPACK FOOTER //
// ./src/store/epics/System.tsx